export const UPLOAD_CHUNK_SIZE = 100 * 1024 * 1024; // 100MB
export const IS_PRODUCTION = process.env.REACT_APP_ENV === 'production' ? true : false;       
export const CONTENT_TYPE = [
  'movie',
  'tv-series',
  'trailer',
  'additional',
  'clip',
  'live_streaming',
  'unknown',
];
export const AGE_RATING = [
  'TV-G',
  'TV-Y',
  'TV-Y7',
  'TV-PG',
  'TV-14',
  'TV-MA',
];

export const AGE_RATING_ODKR_MAP: Record<string, string> = {
  'TV-G': 'All',
  'TV-Y': 'All',
  'TV-Y7': 'R12',
  'TV-PG': 'R13',
  'TV-14': 'R14',
  'TV-MA': 'R16',
};
export const STATUS = ['draft', 'published', 'unpublished'];

// export const LANGUAGE_LIST = ['ko', 'es', 'en', 'jp'];
export const LANGUAGE_LIST = ['ko', 'en', 'ja', 'zh', 'es'];
export const SUBTITLE_FILE_EXTENSION = ['.srt', '.vtt', '.smi'];
export const DUBBING_FILE_EXTENSION = ['.wav', '.aac', '.mp3'];

export const METADATA_SUB_PATHS = ['tag', 'category', 'people', 'series', 'season', 'genre'];

/** Routes that live under the Shorts submenu — keeps it expanded while you're on one. */
export const SHORTS_SUB_PATHS = ['shorts-presets'];

export const THUMBNAIL_UPLOAD_STATE = {
  UPLOADED: 'Uploaded',
  UPLOADING: 'Uploading',
};

export const CONTENT_RULE_TYPE = ['content', 'season', 'series'];

export const COLORS = [
  '#FF3B3B', // Vivid red
  '#00C49F', // Emerald green
  '#FF66CC', // Bright pink
  '#FFBB28', // Golden yellow
  '#9C27B0', // Purple
  '#FF6B3D', // Orange
  '#1976D2', // Deep blue
  '#2E7D32', // Deep green
  '#FFC107', // Yellow
  '#FF9800', // Orange
  '#606060', // Gray
];

export const ACTION_TITLE = {
  ADD: 'Add',
  EDIT: 'Edit',
};

export const DEFAULT_LANGUAGE = 'ko';
export const LANGUAGE_OPTIONS = [
  // Fixed order languages
  { label: 'English', value: 'EN' },
  { label: 'Korean', value: 'KO' },
  { label: 'Simplified Chinese', value: 'ZH-HANS' },
  { label: 'Traditional Chinese', value: 'ZH-HANT' },
  { label: 'Vietnamese', value: 'VI' },
  { label: 'Spanish, Castilian', value: 'ES' },
  { label: 'Japanese', value: 'JA' },
  // Alphabetical order languages
  { label: 'Abkhazian', value: 'AB' },
  { label: 'Afar', value: 'AA' },
  { label: 'Afrikaans', value: 'AF' },
  { label: 'Akan', value: 'AK' },
  { label: 'Albanian', value: 'SQ' },
  { label: 'Amharic', value: 'AM' },
  { label: 'Arabic', value: 'AR' },
  { label: 'Aragonese', value: 'AN' },
  { label: 'Armenian', value: 'HY' },
  { label: 'Assamese', value: 'AS' },
  { label: 'Avaric', value: 'AV' },
  { label: 'Avestan', value: 'AE' },
  { label: 'Aymara', value: 'AY' },
  { label: 'Azerbaijani', value: 'AZ' },
  { label: 'Bambara', value: 'BM' },
  { label: 'Bashkir', value: 'BA' },
  { label: 'Basque', value: 'EU' },
  { label: 'Belarusian', value: 'BE' },
  { label: 'Bengali', value: 'BN' },
  { label: 'Bislama', value: 'BI' },
  { label: 'Bosnian', value: 'BS' },
  { label: 'Breton', value: 'BR' },
  { label: 'Bulgarian', value: 'BG' },
  { label: 'Burmese', value: 'MY' },
  { label: 'Catalan, Valencian', value: 'CA' },
  { label: 'Central Khmer', value: 'KM' },
  { label: 'Chamorro', value: 'CH' },
  { label: 'Chechen', value: 'CE' },
  { label: 'Chichewa, Chewa, Nyanja', value: 'NY' },
  { label: 'Church Slavonic, Old Slavonic, Old Church Slavonic', value: 'CU' },
  { label: 'Chuvash', value: 'CV' },
  { label: 'Cornish', value: 'KW' },
  { label: 'Corsican', value: 'CO' },
  { label: 'Cree', value: 'CR' },
  { label: 'Croatian', value: 'HR' },
  { label: 'Czech', value: 'CS' },
  { label: 'Danish', value: 'DA' },
  { label: 'Divehi, Dhivehi, Maldivian', value: 'DV' },
  { label: 'Dutch, Flemish', value: 'NL' },
  { label: 'Dzongkha', value: 'DZ' },
  { label: 'Esperanto', value: 'EO' },
  { label: 'Estonian', value: 'ET' },
  { label: 'Ewe', value: 'EE' },
  { label: 'Faroese', value: 'FO' },
  { label: 'Fijian', value: 'FJ' },
  { label: 'Finnish', value: 'FI' },
  { label: 'French', value: 'FR' },
  { label: 'Fulah', value: 'FF' },
  { label: 'Gaelic, Scottish Gaelic', value: 'GD' },
  { label: 'Galician', value: 'GL' },
  { label: 'Ganda', value: 'LG' },
  { label: 'Georgian', value: 'KA' },
  { label: 'German', value: 'DE' },
  { label: 'Greek, Modern (1453–)', value: 'EL' },
  { label: 'Guarani', value: 'GN' },
  { label: 'Gujarati', value: 'GU' },
  { label: 'Haitian, Haitian Creole', value: 'HT' },
  { label: 'Hausa', value: 'HA' },
  { label: 'Hebrew', value: 'HE' },
  { label: 'Herero', value: 'HZ' },
  { label: 'Hindi', value: 'HI' },
  { label: 'Hiri Motu', value: 'HO' },
  { label: 'Hungarian', value: 'HU' },
  { label: 'Icelandic', value: 'IS' },
  { label: 'Ido', value: 'IO' },
  { label: 'Igbo', value: 'IG' },
  { label: 'Indonesian', value: 'ID' },
  { label: 'Interlingua (International Auxiliary Language Association)', value: 'IA' },
  { label: 'Interlingue, Occidental', value: 'IE' },
  { label: 'Inuktitut', value: 'IU' },
  { label: 'Inupiaq', value: 'IK' },
  { label: 'Irish', value: 'GA' },
  { label: 'Italian', value: 'IT' },
  { label: 'Javanese', value: 'JV' },
  { label: 'Kalaallisut, Greenlandic', value: 'KL' },
  { label: 'Kannada', value: 'KN' },
  { label: 'Kanuri', value: 'KR' },
  { label: 'Kashmiri', value: 'KS' },
  { label: 'Kazakh', value: 'KK' },
  { label: 'Kikuyu, Gikuyu', value: 'KI' },
  { label: 'Kinyarwanda', value: 'RW' },
  { label: 'Komi', value: 'KV' },
  { label: 'Kongo', value: 'KG' },
  { label: 'Kuanyama, Kwanyama', value: 'KJ' },
  { label: 'Kurdish', value: 'KU' },
  { label: 'Kyrgyz, Kirghiz', value: 'KY' },
  { label: 'Lao', value: 'LO' },
  { label: 'Latin', value: 'LA' },
  { label: 'Latvian', value: 'LV' },
  { label: 'Limburgan, Limburger, Limburgish', value: 'LI' },
  { label: 'Lingala', value: 'LN' },
  { label: 'Lithuanian', value: 'LT' },
  { label: 'Luba-Katanga', value: 'LU' },
  { label: 'Luxembourgish, Letzeburgesch', value: 'LB' },
  { label: 'Macedonian', value: 'MK' },
  { label: 'Malagasy', value: 'MG' },
  { label: 'Malay', value: 'MS' },
  { label: 'Malayalam', value: 'ML' },
  { label: 'Maltese', value: 'MT' },
  { label: 'Manx', value: 'GV' },
  { label: 'Maori', value: 'MI' },
  { label: 'Marathi', value: 'MR' },
  { label: 'Marshallese', value: 'MH' },
  { label: 'Mongolian', value: 'MN' },
  { label: 'Nauru', value: 'NA' },
  { label: 'Navajo, Navaho', value: 'NV' },
  { label: 'Ndonga', value: 'NG' },
  { label: 'Nepali', value: 'NE' },
  { label: 'North Ndebele', value: 'ND' },
  { label: 'Northern Sami', value: 'SE' },
  { label: 'Norwegian', value: 'NO' },
  { label: 'Norwegian Bokmål', value: 'NB' },
  { label: 'Norwegian Nynorsk', value: 'NN' },
  { label: 'Occitan', value: 'OC' },
  { label: 'Ojibwa', value: 'OJ' },
  { label: 'Oriya', value: 'OR' },
  { label: 'Oromo', value: 'OM' },
  { label: 'Ossetian, Ossetic', value: 'OS' },
  { label: 'Pali', value: 'PI' },
  { label: 'Pashto, Pushto', value: 'PS' },
  { label: 'Persian', value: 'FA' },
  { label: 'Polish', value: 'PL' },
  { label: 'Portuguese', value: 'PT' },
  { label: 'Punjabi, Panjabi', value: 'PA' },
  { label: 'Quechua', value: 'QU' },
  { label: 'Romanian, Moldavian, Moldovan', value: 'RO' },
  { label: 'Romansh', value: 'RM' },
  { label: 'Rundi', value: 'RN' },
  { label: 'Russian', value: 'RU' },
  { label: 'Samoan', value: 'SM' },
  { label: 'Sango', value: 'SG' },
  { label: 'Sanskrit', value: 'SA' },
  { label: 'Sardinian', value: 'SC' },
  { label: 'Serbian', value: 'SR' },
  { label: 'Shona', value: 'SN' },
  { label: 'Sichuan Yi, Nuosu', value: 'II' },
  { label: 'Sindhi', value: 'SD' },
  { label: 'Sinhala, Sinhalese', value: 'SI' },
  { label: 'Slovak', value: 'SK' },
  { label: 'Slovenian', value: 'SL' },
  { label: 'Somali', value: 'SO' },
  { label: 'South Ndebele', value: 'NR' },
  { label: 'Southern Sotho', value: 'ST' },
  { label: 'Sundanese', value: 'SU' },
  { label: 'Swahili', value: 'SW' },
  { label: 'Swati', value: 'SS' },
  { label: 'Swedish', value: 'SV' },
  { label: 'Tagalog', value: 'TL' },
  { label: 'Tahitian', value: 'TY' },
  { label: 'Tajik', value: 'TG' },
  { label: 'Tamil', value: 'TA' },
  { label: 'Tatar', value: 'TT' },
  { label: 'Telugu', value: 'TE' },
  { label: 'Thai', value: 'TH' },
  { label: 'Tibetan', value: 'BO' },
  { label: 'Tigrinya', value: 'TI' },
  { label: 'Tonga (Tonga Islands)', value: 'TO' },
  { label: 'Tsonga', value: 'TS' },
  { label: 'Tswana', value: 'TN' },
  { label: 'Turkish', value: 'TR' },
  { label: 'Turkmen', value: 'TK' },
  { label: 'Twi', value: 'TW' },
  { label: 'Uighur, Uyghur', value: 'UG' },
  { label: 'Ukrainian', value: 'UK' },
  { label: 'Urdu', value: 'UR' },
  { label: 'Uzbek', value: 'UZ' },
  { label: 'Venda', value: 'VE' },
  { label: 'Volapük', value: 'VO' },
  { label: 'Walloon', value: 'WA' },
  { label: 'Welsh', value: 'CY' },
  { label: 'Western Frisian', value: 'FY' },
  { label: 'Wolof', value: 'WO' },
  { label: 'Xhosa', value: 'XH' },
  { label: 'Yiddish', value: 'YI' },
  { label: 'Yoruba', value: 'YO' },
  { label: 'Zhuang, Chuang', value: 'ZA' },
  { label: 'Zulu', value: 'ZU' },
];

export const DEFAULT_ORIENTATION = 'landscape';
export const ORIENTATION_OPTIONS = [
  { label: 'Landscape', value: 'landscape' },
  { label: 'Portrait', value: 'portrait' },
  { label: 'Square', value: 'square' },
  { label: 'Lang Clean', value: 'lang_clean' },
];

export const DEFAULT_PRODUCE_COUNTRY = 'KR';
export const PRODUCE_COUNTRIES = [
  { label: 'Korea', value: 'KR' },
  { label: 'China', value: 'CN' },
  { label: 'United States', value: 'US' },
  { label: 'Japan', value: 'JP' },
  { label: 'Vietnam', value: 'VN' },
];

export const DEFAULT_COMPANY_COUNTRY = 'KR';
export const COMPANY_COUNTRIES = [
  { label: '안도라', labelEn: 'Andorra', value: 'AD' },
  { label: '아랍에미리트', labelEn: 'United Arab Emirates', value: 'AE' },
  { label: '아프가니스탄', labelEn: 'Afghanistan', value: 'AF' },
  { label: '앤티가 바부다', labelEn: 'Antigua and Barbuda', value: 'AG' },
  { label: '앵귈라', labelEn: 'Anguilla', value: 'AI' },
  { label: '알바니아', labelEn: 'Albania', value: 'AL' },
  { label: '아르메니아', labelEn: 'Armenia', value: 'AM' },
  { label: '앙골라', labelEn: 'Angola', value: 'AO' },
  { label: '남극', labelEn: 'Antarctica', value: 'AQ' },
  { label: '아르헨티나', labelEn: 'Argentina', value: 'AR' },
  { label: '아메리칸사모아', labelEn: 'American Samoa', value: 'AS' },
  { label: '오스트리아', labelEn: 'Austria', value: 'AT' },
  { label: '오스트레일리아', labelEn: 'Australia', value: 'AU' },
  { label: '아루바', labelEn: 'Aruba', value: 'AW' },
  { label: '올란드 제도', labelEn: 'Åland Islands', value: 'AX' },
  { label: '아제르바이잔', labelEn: 'Azerbaijan', value: 'AZ' },
  { label: '보스니아 헤르체고비나', labelEn: 'Bosnia and Herzegovina', value: 'BA' },
  { label: '바베이도스', labelEn: 'Barbados', value: 'BB' },
  { label: '방글라데시', labelEn: 'Bangladesh', value: 'BD' },
  { label: '벨기에', labelEn: 'Belgium', value: 'BE' },
  { label: '부르키나파소', labelEn: 'Burkina Faso', value: 'BF' },
  { label: '불가리아', labelEn: 'Bulgaria', value: 'BG' },
  { label: '바레인', labelEn: 'Bahrain', value: 'BH' },
  { label: '부룬디', labelEn: 'Burundi', value: 'BI' },
  { label: '베냉', labelEn: 'Benin', value: 'BJ' },
  { label: '생바르텔레미', labelEn: 'Saint Barthélemy', value: 'BL' },
  { label: '버뮤다', labelEn: 'Bermuda', value: 'BM' },
  { label: '브루나이', labelEn: 'Brunei Darussalam', value: 'BN' },
  { label: '볼리비아', labelEn: 'Bolivia, Plurinational State of', value: 'BO' },
  { label: '보네르섬', labelEn: 'Bonaire, Sint Eustatius and Saba', value: 'BQ' },
  { label: '브라질', labelEn: 'Brazil', value: 'BR' },
  { label: '바하마', labelEn: 'Bahamas', value: 'BS' },
  { label: '부탄', labelEn: 'Bhutan', value: 'BT' },
  { label: '부베섬', labelEn: 'Bouvet Island', value: 'BV' },
  { label: '보츠와나', labelEn: 'Botswana', value: 'BW' },
  { label: '벨라루스', labelEn: 'Belarus', value: 'BY' },
  { label: '벨리즈', labelEn: 'Belize', value: 'BZ' },
  { label: '캐나다', labelEn: 'Canada', value: 'CA' },
  { label: '코코스 제도', labelEn: 'Cocos (Keeling) Islands', value: 'CC' },
  { label: '콩고 민주 공화국', labelEn: 'Congo, Democratic Republic of the', value: 'CD' },
  { label: '중앙아프리카 공화국', labelEn: 'Central African Republic', value: 'CF' },
  { label: '콩고 공화국', labelEn: 'Congo', value: 'CG' },
  { label: '스위스', labelEn: 'Switzerland', value: 'CH' },
  { label: '코트디부아르', labelEn: "Côte d'Ivoire", value: 'CI' },
  { label: '쿡 제도', labelEn: 'Cook Islands', value: 'CK' },
  { label: '칠레', labelEn: 'Chile', value: 'CL' },
  { label: '카메룬', labelEn: 'Cameroon', value: 'CM' },
  { label: '중국', labelEn: 'China', value: 'CN' },
  { label: '콜롬비아', labelEn: 'Colombia', value: 'CO' },
  { label: '코스타리카', labelEn: 'Costa Rica', value: 'CR' },
  { label: '쿠바', labelEn: 'Cuba', value: 'CU' },
  { label: '카보베르데', labelEn: 'Cabo Verde', value: 'CV' },
  { label: '퀴라소', labelEn: 'Curaçao', value: 'CW' },
  { label: '크리스마스섬', labelEn: 'Christmas Island', value: 'CX' },
  { label: '키프로스', labelEn: 'Cyprus', value: 'CY' },
  { label: '체코', labelEn: 'Czechia', value: 'CZ' },
  { label: '독일', labelEn: 'Germany', value: 'DE' },
  { label: '지부티', labelEn: 'Djibouti', value: 'DJ' },
  { label: '덴마크', labelEn: 'Denmark', value: 'DK' },
  { label: '도미니카 연방', labelEn: 'Dominica', value: 'DM' },
  { label: '도미니카 공화국', labelEn: 'Dominican Republic', value: 'DO' },
  { label: '알제리', labelEn: 'Algeria', value: 'DZ' },
  { label: '에콰도르', labelEn: 'Ecuador', value: 'EC' },
  { label: '에스토니아', labelEn: 'Estonia', value: 'EE' },
  { label: '이집트', labelEn: 'Egypt', value: 'EG' },
  { label: '서사하라', labelEn: 'Western Sahara', value: 'EH' },
  { label: '에리트레아', labelEn: 'Eritrea', value: 'ER' },
  { label: '스페인', labelEn: 'Spain', value: 'ES' },
  { label: '에티오피아', labelEn: 'Ethiopia', value: 'ET' },
  { label: '핀란드', labelEn: 'Finland', value: 'FI' },
  { label: '피지', labelEn: 'Fiji', value: 'FJ' },
  { label: '포클랜드 제도', labelEn: 'Falkland Islands (Malvinas)', value: 'FK' },
  { label: '미크로네시아 연방', labelEn: 'Micronesia, Federated States of', value: 'FM' },
  { label: '페로 제도', labelEn: 'Faroe Islands', value: 'FO' },
  { label: '프랑스', labelEn: 'France', value: 'FR' },
  { label: '가봉', labelEn: 'Gabon', value: 'GA' },
  { label: '영국', labelEn: 'United Kingdom of Great Britain and Northern Ireland', value: 'GB' },
  { label: '그레나다', labelEn: 'Grenada', value: 'GD' },
  { label: '조지아', labelEn: 'Georgia', value: 'GE' },
  { label: '프랑스령 기아나', labelEn: 'French Guiana', value: 'GF' },
  { label: '건지섬', labelEn: 'Guernsey', value: 'GG' },
  { label: '가나', labelEn: 'Ghana', value: 'GH' },
  { label: '지브롤터', labelEn: 'Gibraltar', value: 'GI' },
  { label: '그린란드', labelEn: 'Greenland', value: 'GL' },
  { label: '감비아', labelEn: 'Gambia', value: 'GM' },
  { label: '기니', labelEn: 'Guinea', value: 'GN' },
  { label: '과들루프', labelEn: 'Guadeloupe', value: 'GP' },
  { label: '적도 기니', labelEn: 'Equatorial Guinea', value: 'GQ' },
  { label: '그리스', labelEn: 'Greece', value: 'GR' },
  {
    label: '사우스조지아 사우스샌드위치 제도',
    labelEn: 'South Georgia and the South Sandwich Islands',
    value: 'GS',
  },
  { label: '과테말라', labelEn: 'Guatemala', value: 'GT' },
  { label: '괌', labelEn: 'Guam', value: 'GU' },
  { label: '기니비사우', labelEn: 'Guinea-Bissau', value: 'GW' },
  { label: '가이아나', labelEn: 'Guyana', value: 'GY' },
  { label: '홍콩', labelEn: 'Hong Kong', value: 'HK' },
  { label: '허드 맥도널드 제도', labelEn: 'Heard Island and McDonald Islands', value: 'HM' },
  { label: '온두라스', labelEn: 'Honduras', value: 'HN' },
  { label: '크로아티아', labelEn: 'Croatia', value: 'HR' },
  { label: '아이티', labelEn: 'Haiti', value: 'HT' },
  { label: '헝가리', labelEn: 'Hungary', value: 'HU' },
  { label: '인도네시아', labelEn: 'Indonesia', value: 'ID' },
  { label: '아일랜드', labelEn: 'Ireland', value: 'IE' },
  { label: '이스라엘', labelEn: 'Israel', value: 'IL' },
  { label: '맨섬', labelEn: 'Isle of Man', value: 'IM' },
  { label: '인도', labelEn: 'India', value: 'IN' },
  { label: '영국령 인도양 지역', labelEn: 'British Indian Ocean Territory', value: 'IO' },
  { label: '이라크', labelEn: 'Iraq', value: 'IQ' },
  { label: '이란', labelEn: 'Iran, Islamic Republic of', value: 'IR' },
  { label: '아이슬란드', labelEn: 'Iceland', value: 'IS' },
  { label: '이탈리아', labelEn: 'Italy', value: 'IT' },
  { label: '저지섬', labelEn: 'Jersey', value: 'JE' },
  { label: '자메이카', labelEn: 'Jamaica', value: 'JM' },
  { label: '요르단', labelEn: 'Jordan', value: 'JO' },
  { label: '일본', labelEn: 'Japan', value: 'JP' },
  { label: '케냐', labelEn: 'Kenya', value: 'KE' },
  { label: '키르기스스탄', labelEn: 'Kyrgyzstan', value: 'KG' },
  { label: '캄보디아', labelEn: 'Cambodia', value: 'KH' },
  { label: '키리바시', labelEn: 'Kiribati', value: 'KI' },
  { label: '코모로', labelEn: 'Comoros', value: 'KM' },
  { label: '세인트키츠 네비스', labelEn: 'Saint Kitts and Nevis', value: 'KN' },
  {
    label: '조선민주주의인민공화국',
    labelEn: "Korea, Democratic People's Republic of",
    value: 'KP',
  },
  { label: '대한민국', labelEn: 'Korea, Republic of', value: 'KR' },
  { label: '쿠웨이트', labelEn: 'Kuwait', value: 'KW' },
  { label: '케이맨 제도', labelEn: 'Cayman Islands', value: 'KY' },
  { label: '카자흐스탄', labelEn: 'Kazakhstan', value: 'KZ' },
  { label: '라오스', labelEn: "Lao People's Democratic Republic", value: 'LA' },
  { label: '레바논', labelEn: 'Lebanon', value: 'LB' },
  { label: '세인트루시아', labelEn: 'Saint Lucia', value: 'LC' },
  { label: '리히텐슈타인', labelEn: 'Liechtenstein', value: 'LI' },
  { label: '스리랑카', labelEn: 'Sri Lanka', value: 'LK' },
  { label: '라이베리아', labelEn: 'Liberia', value: 'LR' },
  { label: '레소토', labelEn: 'Lesotho', value: 'LS' },
  { label: '리투아니아', labelEn: 'Lithuania', value: 'LT' },
  { label: '룩셈부르크', labelEn: 'Luxembourg', value: 'LU' },
  { label: '라트비아', labelEn: 'Latvia', value: 'LV' },
  { label: '리비아', labelEn: 'Libya', value: 'LY' },
  { label: '모로코', labelEn: 'Morocco', value: 'MA' },
  { label: '모나코', labelEn: 'Monaco', value: 'MC' },
  { label: '몰도바', labelEn: 'Moldova, Republic of', value: 'MD' },
  { label: '몬테네그로', labelEn: 'Montenegro', value: 'ME' },
  { label: '생마르탱', labelEn: 'Saint Martin (French part)', value: 'MF' },
  { label: '마다가스카르', labelEn: 'Madagascar', value: 'MG' },
  { label: '마셜 제도', labelEn: 'Marshall Islands', value: 'MH' },
  { label: '북마케도니아', labelEn: 'North Macedonia', value: 'MK' },
  { label: '말리', labelEn: 'Mali', value: 'ML' },
  { label: '미얀마', labelEn: 'Myanmar', value: 'MM' },
  { label: '몽골', labelEn: 'Mongolia', value: 'MN' },
  { label: '마카오', labelEn: 'Macao', value: 'MO' },
  { label: '북마리아나 제도', labelEn: 'Northern Mariana Islands', value: 'MP' },
  { label: '마르티니크', labelEn: 'Martinique', value: 'MQ' },
  { label: '모리타니', labelEn: 'Mauritania', value: 'MR' },
  { label: '몬트세랫', labelEn: 'Montserrat', value: 'MS' },
  { label: '몰타', labelEn: 'Malta', value: 'MT' },
  { label: '모리셔스', labelEn: 'Mauritius', value: 'MU' },
  { label: '몰디브', labelEn: 'Maldives', value: 'MV' },
  { label: '말라위', labelEn: 'Malawi', value: 'MW' },
  { label: '멕시코', labelEn: 'Mexico', value: 'MX' },
  { label: '말레이시아', labelEn: 'Malaysia', value: 'MY' },
  { label: '모잠비크', labelEn: 'Mozambique', value: 'MZ' },
  { label: '나미비아', labelEn: 'Namibia', value: 'NA' },
  { label: '누벨칼레도니', labelEn: 'New Caledonia', value: 'NC' },
  { label: '니제르', labelEn: 'Niger', value: 'NE' },
  { label: '노퍽섬', labelEn: 'Norfolk Island', value: 'NF' },
  { label: '나이지리아', labelEn: 'Nigeria', value: 'NG' },
  { label: '니카라과', labelEn: 'Nicaragua', value: 'NI' },
  { label: '네덜란드', labelEn: 'Netherlands, Kingdom of the', value: 'NL' },
  { label: '노르웨이', labelEn: 'Norway', value: 'NO' },
  { label: '네팔', labelEn: 'Nepal', value: 'NP' },
  { label: '나우루', labelEn: 'Nauru', value: 'NR' },
  { label: '니우에', labelEn: 'Niue', value: 'NU' },
  { label: '뉴질랜드', labelEn: 'New Zealand', value: 'NZ' },
  { label: '오만', labelEn: 'Oman', value: 'OM' },
  { label: '파나마', labelEn: 'Panama', value: 'PA' },
  { label: '페루', labelEn: 'Peru', value: 'PE' },
  { label: '프랑스령 폴리네시아', labelEn: 'French Polynesia', value: 'PF' },
  { label: '파푸아뉴기니', labelEn: 'Papua New Guinea', value: 'PG' },
  { label: '필리핀', labelEn: 'Philippines', value: 'PH' },
  { label: '파키스탄', labelEn: 'Pakistan', value: 'PK' },
  { label: '폴란드', labelEn: 'Poland', value: 'PL' },
  { label: '생피에르 미클롱', labelEn: 'Saint Pierre and Miquelon', value: 'PM' },
  { label: '핏케언 제도', labelEn: 'Pitcairn', value: 'PN' },
  { label: '푸에르토리코', labelEn: 'Puerto Rico', value: 'PR' },
  { label: '팔레스타인', labelEn: 'Palestine, State of', value: 'PS' },
  { label: '포르투갈', labelEn: 'Portugal', value: 'PT' },
  { label: '팔라우', labelEn: 'Palau', value: 'PW' },
  { label: '파라과이', labelEn: 'Paraguay', value: 'PY' },
  { label: '카타르', labelEn: 'Qatar', value: 'QA' },
  { label: '레위니옹', labelEn: 'Réunion', value: 'RE' },
  { label: '루마니아', labelEn: 'Romania', value: 'RO' },
  { label: '세르비아', labelEn: 'Serbia', value: 'RS' },
  { label: '러시아', labelEn: 'Russian Federation', value: 'RU' },
  { label: '르완다', labelEn: 'Rwanda', value: 'RW' },
  { label: '사우디아라비아', labelEn: 'Saudi Arabia', value: 'SA' },
  { label: '솔로몬 제도', labelEn: 'Solomon Islands', value: 'SB' },
  { label: '세이셸', labelEn: 'Seychelles', value: 'SC' },
  { label: '수단', labelEn: 'Sudan', value: 'SD' },
  { label: '스웨덴', labelEn: 'Sweden', value: 'SE' },
  { label: '싱가포르', labelEn: 'Singapore', value: 'SG' },
  { label: '세인트헬레나', labelEn: 'Saint Helena, Ascension and Tristan da Cunha', value: 'SH' },
  { label: '슬로베니아', labelEn: 'Slovenia', value: 'SI' },
  { label: '스발바르 얀마옌', labelEn: 'Svalbard and Jan Mayen', value: 'SJ' },
  { label: '슬로바키아', labelEn: 'Slovakia', value: 'SK' },
  { label: '시에라리온', labelEn: 'Sierra Leone', value: 'SL' },
  { label: '산마리노', labelEn: 'San Marino', value: 'SM' },
  { label: '세네갈', labelEn: 'Senegal', value: 'SN' },
  { label: '소말리아', labelEn: 'Somalia', value: 'SO' },
  { label: '수리남', labelEn: 'Suriname', value: 'SR' },
  { label: '남수단', labelEn: 'South Sudan', value: 'SS' },
  { label: '상투메 프린시페', labelEn: 'Sao Tome and Principe', value: 'ST' },
  { label: '엘살바도르', labelEn: 'El Salvador', value: 'SV' },
  { label: '신트마르턴', labelEn: 'Sint Maarten (Dutch part)', value: 'SX' },
  { label: '시리아', labelEn: 'Syrian Arab Republic', value: 'SY' },
  { label: '에스와티니', labelEn: 'Eswatini', value: 'SZ' },
  { label: '터크스 케이커스 제도', labelEn: 'Turks and Caicos Islands', value: 'TC' },
  { label: '차드', labelEn: 'Chad', value: 'TD' },
  { label: '프랑스령 남방 및 남극 지역', labelEn: 'French Southern Territories', value: 'TF' },
  { label: '토고', labelEn: 'Togo', value: 'TG' },
  { label: '태국', labelEn: 'Thailand', value: 'TH' },
  { label: '타지키스탄', labelEn: 'Tajikistan', value: 'TJ' },
  { label: '토켈라우', labelEn: 'Tokelau', value: 'TK' },
  { label: '동티모르', labelEn: 'Timor-Leste', value: 'TL' },
  { label: '투르크메니스탄', labelEn: 'Turkmenistan', value: 'TM' },
  { label: '튀니지', labelEn: 'Tunisia', value: 'TN' },
  { label: '통가', labelEn: 'Tonga', value: 'TO' },
  { label: '튀르키예', labelEn: 'Türkiye', value: 'TR' },
  { label: '트리니다드 토바고', labelEn: 'Trinidad and Tobago', value: 'TT' },
  { label: '투발루', labelEn: 'Tuvalu', value: 'TV' },
  { label: '중화민국', labelEn: 'Taiwan, Province of China', value: 'TW' },
  { label: '탄자니아', labelEn: 'Tanzania, United Republic of', value: 'TZ' },
  { label: '우크라이나', labelEn: 'Ukraine', value: 'UA' },
  { label: '우간다', labelEn: 'Uganda', value: 'UG' },
  { label: '미국령 군소 제도', labelEn: 'United States Minor Outlying Islands', value: 'UM' },
  { label: '미국', labelEn: 'United States of America', value: 'US' },
  { label: '우루과이', labelEn: 'Uruguay', value: 'UY' },
  { label: '우즈베키스탄', labelEn: 'Uzbekistan', value: 'UZ' },
  { label: '바티칸 시국', labelEn: 'Holy See', value: 'VA' },
  { label: '세인트빈센트 그레나딘', labelEn: 'Saint Vincent and the Grenadines', value: 'VC' },
  { label: '베네수엘라', labelEn: 'Venezuela, Bolivarian Republic of', value: 'VE' },
  { label: '영국령 버진아일랜드', labelEn: 'Virgin Islands (British)', value: 'VG' },
  { label: '미국령 버진아일랜드', labelEn: 'Virgin Islands (U.S.)', value: 'VI' },
  { label: '베트남', labelEn: 'Viet Nam', value: 'VN' },
  { label: '바누아투', labelEn: 'Vanuatu', value: 'VU' },
  { label: '왈리스 푸투나', labelEn: 'Wallis and Futuna', value: 'WF' },
  { label: '사모아', labelEn: 'Samoa', value: 'WS' },
  { label: '예멘', labelEn: 'Yemen', value: 'YE' },
  { label: '마요트', labelEn: 'Mayotte', value: 'YT' },
  { label: '남아프리카 공화국', labelEn: 'South Africa', value: 'ZA' },
  { label: '잠비아', labelEn: 'Zambia', value: 'ZM' },
  { label: '짐바브웨', labelEn: 'Zimbabwe', value: 'ZW' },
];

export const CONTINENTS = [
  { label: '아프리카', labelEn: 'Africa', value: 'AFRICA' },
  { label: '남극', labelEn: 'Antarctica', value: 'ANTARCTICA' },
  { label: '아시아', labelEn: 'Asia', value: 'ASIA' },
  { label: '유럽', labelEn: 'Europe', value: 'EUROPE' },
  { label: '북아메리카', labelEn: 'North America', value: 'NORTH_AMERICA' },
  { label: '오세아니아', labelEn: 'Oceania', value: 'OCEANIA' },
  { label: '남아메리카', labelEn: 'South America', value: 'SOUTH_AMERICA' },
  { label: '전세계', labelEn: 'Worldwide', value: 'WORLDWIDE' },
];

export const DEFAULT_CAST_TYPE = 'actor';
export const CAST_TYPE_OPTIONS = [
  { label: 'Actor', value: 'actor' },
  { label: 'Director', value: 'director' },
  { label: 'Writer', value: 'writer' },
  { label: 'Producer', value: 'producer' },
  { label: 'Composer', value: 'composer' },
  { label: 'Voice Actor', value: 'voice_actor' },
];

export const SERIES_DUBBING_MODE = {
  enabled: 'Enabled',
  disabled: 'Disabled',
};

export const DUBBING_MODE = {
  enabled: 'Enabled',
  disabled: 'Disabled',
  inherit: 'Inherit',
};

export const DEFAULT_PAGE_SIZE_OPTIONS = ['10', '20', '50'];
export const EXPAND_ICON = {
  EXPANDED: '▼',
  COLLAPSED: '▶',
};

export const POSTER_LANGUAGE_OPTIONS = [
  { label: 'Korean', value: 'KO' },
  { label: 'English', value: 'EN' },
  { label: 'Simplified Chinese', value: 'ZH-HANS' },
  { label: 'Traditional Chinese', value: 'ZH-HANT' },
  { label: 'Japanese', value: 'JP' },
];

export const comboColorMap: Record<string, string> = {
  'ko-landscape': '#FFDCE0',
  'ko-portrait': '#FFF5B1',
  'en-landscape': '#CEE5D0',
  'en-portrait': '#D0E7FF',
  'zh-hans-landscape': '#E4D7F5',
  'zh-hans-portrait': '#FDE2C8',
  'zh-hant-landscape': '#BFE9FF',
  'zh-hant-portrait': '#E3F6D5',
  'ja-landscape': '#17F5EF',
  'ja-portrait': '#B3F6D5',
};

// Platform id branching (backend-assigned ids): 1 = ODK, 2 = CP.
//
// Vietnam 전용 platform(구 id=3)은 폐지됐다. LG Channel Vietnam CP는 ODK platform으로 통합되고
// 접근 판정은 flag + permission code로 넘어갔다 — `constants/permission.ts` 참고.
// (platform은 테넌트 경계이지 권한 단위가 아니고, env로만 존재하던 자격 목록이 DB로 이동했다.)

export const PLATFORM_TYPES = [
  { label: 'All Platforms', value: 'ALL' },
  { label: 'ODK', value: 'ODK' },
  { label: 'ODC', value: 'ODC' },
  { label: 'ODV', value: 'ODV' },
  { label: 'ODL', value: 'ODL' },
  { label: 'AMASIAN', value: 'AMASIAN' },
];

export const S3_BUCKET_NAME =
  process.env.REACT_APP_S3_BUCKET_NAME || 'stg-ondemandkorea-cp-uploaded-content';

export const CLOUDFRONT_DOMAIN =
  process.env.REACT_APP_CLOUDFRONT_DOMAIN || 'https://d1rz8umx2a4nuw.cloudfront.net';
